import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import EventIcon from 'APP_ROOT/components/common/eventIcon';
import EventCluster from './EventCluster';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import { makeEventId } from './../../../../data/events/actions';

import EventItem from './EventItem';

// NOTE: This is very similar to the class in the dashboard page
// changes here should be reflected there as well

export default class EventScrollableList extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            startLocation: null,
            endLocation: null,
        };
    }

    updateLocation = (statePropertyName, locationFeatures) => {

        const locationName = RavenUtil.getLocationName(locationFeatures);

        if (!locationName) {
            console.warn("EventScrollableList locationName not found");
            return;
        }

        this.setState({
            [statePropertyName] : locationName
        });
    }

    createStartEvent(geoinfo) {

        var index = 998;

        var timestamp = RavenUtil.toDate(geoinfo.ts).toLocaleString(getCurrentLocale(), {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});

        if(!this.state.startLocation)
        {
            if(geoinfo)
            {
                RavenUtil.getLocationFeatures(geoinfo.lon, geoinfo.lat,
                    (info) => { this.updateLocation('startLocation', info); },
                    (error) => {
                        if(geoinfo.lon && geoinfo.lat)
                            this.setState({startLocation: "" + geoinfo.lon + " " + geoinfo.lat});
                        else
                            this.setState({startLocation: strings.unknown});
                    }
                );
            }
            else
            {
                this.setState({startLocation: strings.unknown});
            }
        }

        return (
            <li key={index} className="event-item">
                <div className="event-icon-start">
                    <EventIcon type="START" index={index} />
                </div>
                <div className="event-boundary-details location-name">
                    <span className="event-title">
                        {this.state.startLocation}
                    </span>
                    <span className="event-timestamp">{timestamp}</span>
                </div>
            </li>
        );

    }

    createEndEvent(geoinfo) {

        var timestamp;

        if(geoinfo.ts)
            timestamp = RavenUtil.toDate(geoinfo.ts).toLocaleString(getCurrentLocale(), {month: "short", day: "numeric", hour: "numeric", minute: "numeric"});
        else
            timestamp = strings.ongoing;

        if(!this.state.endLocation)
        {
            if(geoinfo)
            {
                RavenUtil.getLocationFeatures(geoinfo.lon, geoinfo.lat,
                    (info) => { this.updateLocation('endLocation', info); },
                    (error) => {
                        if(geoinfo.lon && geoinfo.lat)
                            this.setState({endLocation: "" + geoinfo.lon + " " + geoinfo.lat});
                        else
                            this.setState({endLocation: strings.unknown});
                    }
                );
            }
            else
            {
                this.setState({endLocation: strings.unknown});
            }
        }

        var index = 999;

        return (
            <li key={index} className="event-item">
                <div className="event-icon-end">
                    <EventIcon type="END" index={index} />
                </div>
                <div className="event-boundary-details location-name">
                    <span className="event-title">
                        {this.state.endLocation}
                    </span>
                    <span className="event-timestamp">{timestamp}</span>
                </div>
            </li>
        );

    }

    createEventList() {

        var eventList = [];

        let selectedEventId = undefined;
        if (this.props.selectedEvent) {
            selectedEventId = this.props.selectedEvent.eventId || makeEventId(this.props.selectedEvent);
        }


        // End Event
        if (!this.props.renderForDashboard) {
            eventList.push(this.createEndEvent(this.props.card.end));
        }

        if (this.props.events && this.props.events.length > 0) {

            for (let i = 0; i < this.props.events.length; i += 1) {
                if (!this.props.events[i].clustered) {
                    const eventId = this.props.events[i].eventId || makeEventId(this.props.events[i]);
                    eventList.push(<EventItem
                        ravenUuid={this.props.ravenUuid}
                        event={this.props.events[i]}
                        card={this.props.card}
                        unitOfMeasure={this.props.unitOfMeasure}
                        key={i}
                        index={i}
                        selected={selectedEventId === eventId}
                        selectEvent={this.selectEvent}
                        referenceTime={this.props.events[0].ts}
                        mediaRequestType={this.props.mediaRequestType}
                        renderForDashboard={this.props.renderForDashboard}
                        allSupportedEvents={this.props.allSupportedEvents}
                    />);
                } else {
                    let clusterSize = this.props.events[i].clusterSize; // first event in cluster has clusterSize
                    let clusterEvents = [this.props.events[i]];
                    for (let j = i + 1; j - i < clusterSize; j += 1) {
                        clusterEvents.push(this.props.events[j]);
                    }
                    i += clusterSize - 1; // `-1` accommodates the `i += 1` in the for-loop
                    
                    eventList.push(<EventCluster
                        key={i}
                        events={clusterEvents}
                        onSelectEvent={this.selectEvent}
                        ravenUuid={this.props.ravenUuid}
                        card={this.props.card}
                        unitOfMeasure={this.props.unitOfMeasure}
                        selectedEvent={this.props.selectedEvent}
                        referenceTime={this.props.events[0].ts}
                        mediaRequestType={this.props.mediaRequestType}
                        renderForDashboard={this.props.renderForDashboard}
                        allSupportedEvents={this.props.allSupportedEvents}
                    />);
                };
            }
        }

        if (!this.props.renderForDashboard) {
            eventList.push(this.createStartEvent(this.props.card.start));
        }

        return eventList;
    }

    selectEvent = (event) => {
        this.props.onSelectEvent(event);
    }

    render() {

        if (this.props.events && this.props.events.length > 0) {

            var eventList = this.createEventList();

            return (
                <ul className="event-table">
                    {eventList}
                </ul>
            );
        } else {

            return (
                <p>{strings.formatString(strings.db_no_events_list)}</p>
            );
        }

    }
}

EventScrollableList.propTypes = {
    events: PropTypes.array,
    mediaRequestType: PropTypes.string.isRequired,
    card: PropTypes.object, // for adding speedzones
    unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
    selectedEvent: PropTypes.object,
    onSelectEvent: PropTypes.func,
    renderForDashboard: PropTypes.bool,
    allSupportedEvents: PropTypes.array // legacy/dashboard
};
